// src/components/Auth/UnauthorizedPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './AuthPages.module.css'; // We'll create this shared style file
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faSignInAlt } from '@fortawesome/free-solid-svg-icons';

const UnauthorizedPage = () => {
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    // Replace '/login' with your actual login page route
    navigate('/login');
  };

  return (
    <div className={styles.authPageContainer}>
      <div className={styles.authCard}>
        <div className={styles.iconWrapper}>
          <FontAwesomeIcon icon={faLock} className={styles.mainIcon} />
        </div>
        <h1 className={styles.title}>Access Denied</h1>
        <p className={styles.message}>
          You do not have the necessary permissions to access this page.
          This area is restricted to authorized personnel only.
        </p>
        <p className={styles.suggestion}>
          If you believe you should have access, please ensure you are logged in
          with the correct account or contact an administrator.
        </p>
        <button
          onClick={handleLoginRedirect}
          className={styles.actionButton}
        >
          <FontAwesomeIcon icon={faSignInAlt} className={styles.buttonIcon} />
          Proceed to Login
        </button>
        {/* Optional: Link to go back to homepage */}
        {/* <button
          onClick={() => navigate('/')} // Assuming '/' is your homepage
          className={`${styles.actionButton} ${styles.secondaryButton}`}
        >
          Go to Homepage
        </button> */}
      </div>
      <footer className={styles.authFooter}>
        © {new Date().getFullYear()} Digi Savvy. All rights reserved.
      </footer>
    </div>
  );
};

export default UnauthorizedPage;